import { render, staticRenderFns } from "./MaintenanceItemTypeFormDialog.vue?vue&type=template&id=19985c79"
import script from "./MaintenanceItemTypeFormDialog.vue?vue&type=script&lang=ts"
export * from "./MaintenanceItemTypeFormDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports